import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { type UseMutationOptions } from '@tanstack/react-query/src/types';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';

import {
  type TDeleteOfferFromComparisonRequest,
  type TDeleteOfferFromComparisonResponse_1,
} from '@/repositories/generated/shared/offers-comparison/v1/delete-offer-from-comparison';

import { type QueryError, getQueryKey } from './internal/config';
import { fetchDeleteComparisonService } from './internal/fetchService';

export function useDeleteFromComparisonMutation<TContext = unknown>(
  options?: Omit<
    UseMutationOptions<TDeleteOfferFromComparisonResponse_1, QueryError, TDeleteOfferFromComparisonRequest, TContext>,
    'mutationKey' | 'mutationFn'
  >,
): UseMutationResult<TDeleteOfferFromComparisonResponse_1, QueryError, TDeleteOfferFromComparisonRequest, TContext> {
  const context = useQueryStateAppContext();

  return useMutation<TDeleteOfferFromComparisonResponse_1, QueryError, TDeleteOfferFromComparisonRequest, TContext>({
    mutationFn: parameters => fetchDeleteComparisonService(context, parameters),
    mutationKey: getQueryKey(),
    ...options,
  });
}
